import api from '@/services/api.service';

export default {
    name: 'list',
    components: {},
    props: {
        caption: {
            type: String,
            default: 'Marketing Agent list'
        },
        hover: {
            type: Boolean,
            default: true
        },
        striped: {
            type: Boolean,
            default: true
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            items: [],
            fields: [
            { key: '#' },
            { key: 'agent_name', sortable: true },
            { key: 'marketing_event', sortable: true },
            { key: 'status', sortable: true },
            { key: 'actions' }
            ],
            sech: {},
            currentPage: 1,
            perPage: 10,
            totalRows: null,
            totalMarketing: null,
            isBusy: true,
            delete_ids: [],
            allSelected: false,
            file_path: process.env.VUE_APP_EVENT_REQUEST_FILE_URL,
            permission_addAgent: false,           
            permission_deleteAgent: false,   
            permission_listAgent: false,
            permission_downloadRequestedContacts: false ,
            superAdmin: false
        };
    },
    computed: {},
    mounted() {},
    async created() {
        let response = await api.post("users/user-permissions");
            const permissions = [];
            if (response.status == "success") {
              response.data[0].permission.forEach( function(element) {                
                  permissions.push(element.action)
              }.bind(this));
              if(permissions.includes("list_agent_event") == true || permissions.includes("add_agent_event") == true ){
                this.getAgentList();
                this.permission_addAgent = permissions.includes("add_agent_event");
                this.permission_listAgent = permissions.includes("list_agent_event");
                this.permission_deleteAgent = permissions.includes("delete_agent_event");
                this.permission_downloadRequestedContacts = permissions.includes("download_contact_agent_event");
              }else if(response.data[0].role == 'super_admin'){
                this.getAgentList();
                this.superAdmin = true;
              }else if(permissions.includes("list_event") == true || permissions.includes("add_event") == true){
                  this.makeToast("Permission denied","Alert","warning",6000);
                  this.$router.push({name: 'List Event'});
              }else{
                  this.makeToast("Permission denied","Alert","warning",6000);
                  this.$router.push({name: 'Admin Dashboard'});
              }
            }
    },
    watch: {
        currentPage: {
            handler: function(page) {
                this.getAgentList(page);
            }
        }
    },
    methods: {
        makeToast(message = '', title = 'Alert', variant = 'warning') {
            this.toastCount++;
            this.$root.$bvToast.toast(message, {
                title: title,
                variant: variant,
                autoHideDelay: 3000
            });
        },
        selectAll: function(e) {
            this.delete_ids = [];
            if (e.target.checked) {
                for (var item in this.items) {
                    this.delete_ids.push(this.items[item].id.toString());
                }
            }
        },
        selectOne() {
            this.allSelected = false;
        },
        async toSort (page = 1)
        {   
            this.isBusy=true;
            this.sech.page = page;
            this.sech.paginateVal = this.perPage;
            this.sech.marketing_event_id = this.$route.params.id;
            let response = await api.post('admin/marketing-event/agent/list', this.sech);
            if (!response) this.makeToast('Something went to wrong please try again', 'Alert', 'danger', 6000);
            if (response.status == 'success') {
                if (response.data != '') {
                    this.items = response.data.data;
                    this.totalCampaign = response.data.total;
                    this.currentPage = response.data.current_page;
                    this.perPage = response.data.per_page;
                } else {
                    this.items = [];
                }
            }
            this.isBusy = false; 
        },
        async getAgentList(page) {
            this.isBusy=true;
            this.sech.page = page;
            this.sech.paginateVal = this.perPage;
            this.sech.marketing_event_id = this.$route.params.id;
            let response = await api.post('admin/marketing-event/agent/list', this.sech);
            if (!response) this.makeToast('Something went to wrong please try again', 'Alert', 'danger', 6000);
            if (response.status == 'success') {
                if (response.data != '') {
                    this.items = response.data.data;
                    this.totalCampaign = response.data.total;
                    this.currentPage = response.data.current_page;
                    this.perPage = response.data.per_page;

                    this.pageOptions.forEach(element => {
                        if(element.value > this.totalCampaign){
                            var indexOf = this.pageOptions.indexOf(element);
                            if( indexOf != 0 )
                            this.pageOptions.splice(indexOf)
                        }
                    });
                    if(this.totalCampaign <= 500)
                    this.pageOptions.push({text:'All',value:this.totalCampaign});
                } else {
                    this.items = [];
                }
            }
            // else{
            //     this.makeToast(response.message, 'Alert', 'warning', 6000);
            //     this.$router.push({name: "List Event"});
            // }
            this.isBusy = false;
        },
        getRowCount(items) {
            return items.length;
        },
        updateAgent(id) {
            this.$router.push({ name: 'Edit Agent', params: { agent_req_id: id } });
        },
        multipleDelete() {
            this.$bvModal
            .msgBoxConfirm('Are you sure want to delete this Marketing Event?')
            .then(value => {
                if (value) {
                    this.deleteMarketing(this.delete_ids, 0);
                } else {
                    return;
                }
            })
            .catch(function() {
                return;
            });
        },
        singleDelete(id, index) {
            this.$bvModal
            .msgBoxConfirm('Are you sure want to delete this Marketing Event?')
            .then(value => {
                if (value) {
                    this.deleteMarketing(id, index);
                } else {
                    return;
                }
            })
            .catch(function() {
                return;
            });
        },
        async deleteMarketing(id, index) {
            let response = await api.post('admin/marketing-event/agent/delete', {
                id: id
            });

            if (!response) this.makeToast('Something went to wrong please try again', 'Alert', 'danger', 6000);

            if (response.status == 'success') {
                if (index == 0) {
                    this.getAgentList();
                } else {
                    this.items.splice(index, 1);
                }

                this.makeToast(response.message || `Marketing Event delete successful.`, 'Alert', 'success');
            } else {
                this.makeToast(`Marketing Event not deleted.`, 'Alert', 'danger');
            }
        },
        assignVendor(id) {
            this.$router.push({ name: 'Assign Vendor', params: { id: id } });
        },
        uploadResponse(id) {
            this.$router.push({ name: 'Upload Response', params: { id: id } });
        },
        showResult() {
            this.$router.push({ name: 'Show Result' });
        },
        editVendor(id) {
            this.$router.push({ name: 'Edit Vendor', params: { id: id } });
        },
        agentRequestContactList(id) {
            this.$router.push({ name: 'Agent Request Contacts', params: { request_id: id, marketing_event_id : this.$route.params.id } });
        },
        async downloadMarketingRequestContacts(request_id)
        {

          let response = await api.post("marketing-event/download-marketing-request-contacts",
            { marketing_event_id: this.$route.params.id ,request_id : request_id });

          if (!response)
            this.makeToast("Something went to wrong please try again","Alert","danger",6000);

        if (response.status == "success") {        
            window.open(response.data, "_blank");
            this.makeToast(`Marketing Event download successful.`,"Alert","success");
        } 
        else 
            for (var error in response.errors)
              this.makeToast(response.errors[error], 'Alert', 'danger', 6000)

      },
      ResponseContactList(id) {
        this.$router.push({ name: 'Response Contacts', params: { id: id } });
    }
}
};
